import FlashlightText from "@/components/base/FlashlightText";

export default function Home() {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      {/* Top nav */}
      <header className="w-full px-8 md:px-14 py-6 flex items-center justify-between relative z-20">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-md bg-white flex items-center justify-center">
            <i className="ri-flashlight-fill text-black text-lg"></i>
          </div>
          <span className="text-lg font-semibold tracking-tight">Originkit</span>
        </div>
        <nav className="hidden md:flex items-center gap-8 text-sm text-white/70">
          <a href="#work" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Work</a>
          <a href="#studio" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Studio</a>
          <a href="#journal" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Journal</a>
          <a href="#contact" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Contact</a>
        </nav>
        <a
          href="#contact"
          className="hidden md:inline-flex items-center gap-2 text-sm font-medium bg-white text-black px-4 py-2 rounded-full hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap"
        >
          Get in touch
          <i className="ri-arrow-right-up-line"></i>
        </a>
      </header>

      {/* Hero */}
      <section className="relative flex-1 flex flex-col items-center justify-center px-6 md:px-12 py-16 md:py-24 overflow-hidden">
        {/* Subtle background grid */}
        <div
          className="pointer-events-none absolute inset-0 opacity-[0.08]"
          style={{
            backgroundImage:
              "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)",
            backgroundSize: "80px 80px",
          }}
        />
        <div className="pointer-events-none absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-black to-transparent" />
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-black to-transparent" />

        {/* Flashlight headline */}
        <div className="relative z-10 w-full max-w-5xl">
          <FlashlightText
            text={"Not everything is meant\nto be seen at once."}
            font={{
              fontFamily: "'Funnel Display', system-ui, sans-serif",
              fontSize: "clamp(56px, 9vw, 128px)",
              fontWeight: 700,
              lineHeight: "1.05em",
              letterSpacing: "-0.02em",
              textAlign: "center",
            }}
            brightColor="#FFFFFF"
            dimColor="#141414"
            maskSize={280}
            intensity={14}
          />
        </div>

        {/* CTAs */}
        <div className="relative z-10 mt-20 md:mt-28 flex flex-col sm:flex-row items-center gap-3">
          <a
            href="#work"
            className="inline-flex items-center gap-2 rounded-full bg-white text-black px-6 py-3 text-sm font-medium hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap"
          >
            Explore the work
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </section>
    </div>
  );
}